import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, AccordionActions, 
  Typography, Tooltip, IconButton, Button } from '@mui/material'
import { Add as AddIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'

export default function SelectedFeatures(props) {
  return (
    <div>
      {props.features.length > 0 &&
        <Accordion disableGutters expanded={props.expanded === 'SelectedFeatures'} onChange={props.handleChange('SelectedFeatures')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold', alignItems: 'center'}} gutterBottom>
            Cellule sélectionnées:&nbsp;
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>{props.features.length} item{props.features.length > 1 && 's'}</Typography>
          </AccordionSummary>
          <AccordionDetails style={{maxHeight: '35vh', overflow: 'auto'}}>
            {props.features.map((feature, index) => (
              <div key={index}>
                <Tooltip title="Center on asset" placement="left">
                  <Button onClick={() => props.centerOnFeature(feature)}>
                    Label: {feature.get('asset')['label']}
                  </Button>
                </Tooltip>
                {Object.keys(feature.get('asset')['features']).map((key, iindex) => (
                  <Typography key={iindex} sx={{ pl: 4 }}>
                    {key}: {JSON.stringify(feature.get('asset')['features'][key])}
                  </Typography>
                ))}
              </div>
            ))}
          </AccordionDetails>
        </Accordion>
      }
    </div>
  )
}